<template>
  <div class="bc-spec-order">
    <div class="bc-spec-order__inner">
      <a class="bc-spec-order__back" href="javascript:;" @click.prevent="goBack">
        ← {{ $T('观众中心返回') }}
      </a>
      <h1 class="bc-spec-order__title">{{ $T('观众中心确认订单') }}</h1>

      <section class="bc-spec-order__card">
        <div class="bc-spec-order__card-head">
          <h2>{{ $T('观众中心收货地址') }}</h2>
          <button type="button" class="bc-spec-order__link" @click="showAddressForm = !showAddressForm">
            {{ showAddressForm ? $T('观众中心取消') : $T('观众中心新增地址') }}
          </button>
        </div>

        <div v-if="showAddressForm" class="bc-spec-order__addr-form">
          <div class="bc-spec-order__field">
            <label>{{ $T('观众中心姓名') }}</label>
            <input v-model="addrForm.name" type="text" />
          </div>
          <div class="bc-spec-order__field">
            <label>{{ $T('观众中心手机') }}</label>
            <input v-model="addrForm.phone" type="text" />
          </div>
          <div class="bc-spec-order__field">
            <label>{{ $T('观众中心地区') }}</label>
            <button type="button" class="bc-spec-order__area-btn" @click="areaShow = true">
              {{ areaText || $T('观众中心请选择地区') }}
            </button>
          </div>
          <div class="bc-spec-order__field">
            <label>{{ $T('观众中心详细地址') }}</label>
            <input v-model="addrForm.address" type="text" />
          </div>
          <button type="button" class="bc-spec-order__secondary" @click="saveAddress">
            {{ $T('观众中心保存地址') }}
          </button>
        </div>

        <div v-else-if="!addressList.length" class="bc-spec-order__hint">
          {{ $T('观众中心请先添加地址') }}
        </div>
        <div v-else class="bc-spec-order__addr-list">
          <label
            v-for="item in addressList"
            :key="item.id"
            class="bc-spec-order__addr-item"
            :class="{ 'is-active': addressId == item.id }"
          >
            <input
              type="radio"
              name="address"
              :value="item.id"
              v-model="addressId"
              @change="onAddressChange"
            />
            <div>
              <div class="bc-spec-order__addr-name">
                {{ item.name }} {{ item.tel || item.phone }}
              </div>
              <div class="bc-spec-order__addr-detail">
                {{ formatAddress(item) }}
              </div>
            </div>
          </label>
        </div>
      </section>

      <section class="bc-spec-order__card" v-if="orderList.length">
        <h2 class="bc-spec-order__card-head">{{ $T('观众中心商品信息') }}</h2>
        <div
          v-for="(order, oi) in orderList"
          :key="'o' + oi"
          class="bc-spec-order__goods-block"
        >
          <div
            v-for="(goods, gi) in order.goods_items"
            :key="'g' + gi"
            class="bc-spec-order__goods"
          >
            <img :src="goods.pic_url || goods.pic" alt="" />
            <div class="bc-spec-order__goods-meta">
              <div class="bc-spec-order__goods-title">{{ goodsTitle(goods) }}</div>
              <div class="bc-spec-order__goods-sku" v-if="goods.property_name">
                {{ goods.property_name }}
              </div>
              <div class="bc-spec-order__goods-row">
                <span>{{ money(goods.price) }}</span>
                <span>× {{ goods.count }}</span>
              </div>
            </div>
          </div>
          <div class="bc-spec-order__sub">
            <span>{{ $T('观众中心运费') }}：{{ money(order.express_price || 0) }}</span>
            <span>{{ $T('观众中心小计') }}：{{ money(order.pay_price || 0) }}</span>
          </div>
        </div>
      </section>

      <div v-if="warnings.length" class="bc-spec-order__warn">
        <p v-for="(w, i) in warnings" :key="i">{{ w }}</p>
      </div>

      <div class="bc-spec-order__footer">
        <div class="bc-spec-order__total">
          {{ $T('观众中心应付') }}：
          <strong>{{ money(payPrice) }}</strong>
        </div>
        <button
          type="button"
          class="bc-spec-order__submit"
          :disabled="submitting"
          @click="submitOrder"
        >
          {{ $T('观众中心提交订单') }}
        </button>
      </div>
    </div>

    <van-popup v-model="areaShow" position="bottom" :style="{ height: '40%' }">
      <van-area :area-list="areaListData" @confirm="areaConfirm" @cancel="areaShow = false" />
    </van-popup>

    <LoginDialog
      :show="loginShow"
      @loginSuccess="loginSuccess"
      @loginCancel="loginCancel"
    />
    <SpectatorOfflinePayDialog
      :show="payDialogShow"
      :ids="orderIds"
      :pay-price="payPrice"
      @onPaid="onOfflinePaid"
      @onClose="onPayClose"
    />
  </div>
</template>

<script>
import { Toast, Popup, Area } from 'vant';
import areaList from '@/utils/area';
import LoginDialog from '@/components/LoginDialog.vue';
import SpectatorOfflinePayDialog from '@/page/mainindex/SpectatorOfflinePayDialog.vue';
import { spectatorMoney } from '@/utils/spectatorMoney';

const BUY_KEY = 'spectator_buy_goods_items';

export default {
  name: 'SpectatorOrderConfirm',
  components: {
    LoginDialog,
    SpectatorOfflinePayDialog,
    [Popup.name]: Popup,
    [Area.name]: Area,
  },
  data() {
    return {
      goodsItems: [],
      addressList: [],
      addressId: 0,
      orderList: [],
      payPrice: 0,
      warnings: [],
      showAddressForm: false,
      addrForm: {
        name: '',
        phone: '',
        address: '',
        area_key: '',
        province: '',
        city: '',
        county: '',
        is_default: true,
      },
      areaShow: false,
      areaListData: areaList,
      submitting: false,
      loginShow: false,
      payDialogShow: false,
      orderIds: [],
    };
  },
  computed: {
    areaText() {
      const f = this.addrForm;
      if (!f.province) return '';
      return `${f.province}${f.city}${f.county}`;
    },
  },
  mounted() {
    document.title = this.$T('观众中心确认订单');
    this.loadBuyItems();
    this.ensureLoginThenInit();
  },
  methods: {
    money: spectatorMoney,
    goodsTitle(goods) {
      if (this.$getLocale() === 'en-US' && goods.title_en) {
        return goods.title_en;
      }
      return goods.title || '';
    },
    formatAddress(item) {
      // addressList 接口会把省市区拼进 address；有完整串时直接用
      if (item.address && String(item.address).indexOf(item.province || '') === 0) {
        return item.address;
      }
      const p = item.province || '';
      const c = item.city || '';
      const county = item.county || '';
      const detail = item.addressDetail || item.address || '';
      return `${p === c ? c : p + c}${county}${detail}`;
    },
    loadBuyItems() {
      try {
        const raw = sessionStorage.getItem(BUY_KEY);
        this.goodsItems = raw ? JSON.parse(raw) : [];
      } catch (e) {
        this.goodsItems = [];
      }
      if (!this.goodsItems.length) {
        Toast(this.$T('观众中心无待结算商品'));
        this.$router.replace({ path: '/spectator' });
      }
    },
    goBack() {
      this.$router.back();
    },
    ensureLoginThenInit() {
      const that = this;
      that.$api.post(
        '/api/index/userdata',
        {},
        () => {
          that.loadAddresses();
        },
        (res) => {
          if (res && (res.code == 401 || res.code == 402)) {
            that.loginShow = true;
          } else if (!localStorage.getItem('_token') && !localStorage.getItem('_pspt')) {
            that.loginShow = true;
          } else {
            Toast((res && res.msg) || that.$T('观众中心请先登录'));
            that.loginShow = true;
          }
        }
      );
    },
    loginSuccess() {
      this.loginShow = false;
      this.loadAddresses();
    },
    loginCancel() {
      this.loginShow = false;
      this.$router.replace({ path: '/spectator' });
    },
    loadAddresses() {
      const that = this;
      that.$api.get(
        '/api/user/addressList',
        {},
        (res) => {
          that.addressList = res.data || [];
          if (that.addressList.length && !that.addressId) {
            const def =
              that.addressList.find((a) => a.is_default == 1) || that.addressList[0];
            that.addressId = def.id;
          }
          if (!that.addressList.length) {
            that.showAddressForm = true;
          }
          that.loadFormData();
        },
        () => {
          that.addressList = [];
          that.showAddressForm = true;
          that.loadFormData();
        }
      );
    },
    onAddressChange() {
      this.loadFormData();
    },
    loadFormData() {
      if (!this.goodsItems.length) return;
      const that = this;
      that.$api.post(
        '/api/order/formdata',
        {
          goods_items: that.goodsItems,
          address_id: that.addressId || 0,
          express_type: 1,
        },
        (res) => {
          const data = res.data || {};
          that.orderList = data.order_list || [];
          that.payPrice = data.pay_price || 0;
          that.warnings = data.warnings || [];
          if (data.address_id) {
            that.addressId = data.address_id;
          }
        },
        (res) => {
          Toast((res && res.msg) || that.$T('观众中心订单预览失败'));
        }
      );
    },
    areaConfirm(data) {
      this.addrForm.province = data[0].name;
      this.addrForm.city = data[1].name;
      this.addrForm.county = data[2].name;
      this.addrForm.area_key = data[2].code;
      this.areaShow = false;
    },
    saveAddress() {
      const f = this.addrForm;
      if (!f.name || !f.phone || !f.county || !f.address) {
        Toast(this.$T('观众中心请完善地址'));
        return;
      }
      const that = this;
      that.$api.get(
        '/api/user/addressAdd',
        {
          name: f.name,
          phone: f.phone,
          address: f.address,
          area_key: f.area_key,
          province: f.province,
          city: f.city,
          county: f.county,
          is_default: f.is_default ? 1 : 2,
        },
        (res) => {
          Toast.success(that.$T('观众中心地址已保存'));
          that.showAddressForm = false;
          that.addrForm = {
            name: '',
            phone: '',
            address: '',
            area_key: '',
            province: '',
            city: '',
            county: '',
            is_default: true,
          };
          if (res.data && res.data.id) {
            that.addressId = res.data.id;
          }
          that.loadAddresses();
        },
        (res) => {
          Toast((res && res.msg) || that.$T('观众中心地址保存失败'));
        }
      );
    },
    buildOrderGoodsItems() {
      // orderAdd 走 createAddBusinessOrderItems，需要 formdata 回填后的 price 等字段
      const items = [];
      (this.orderList || []).forEach((order) => {
        (order.goods_items || []).forEach((g) => {
          items.push({
            goods_id: g.goods_id,
            sku_id: g.sku_id,
            count: g.count,
            property_name: g.property_name || '',
            price: g.price != null ? g.price : 0,
            discount_price: g.discount_price != null ? g.discount_price : 0,
            credit_limit: g.credit_limit != null ? g.credit_limit : 0,
            use_credit: g.use_credit != null ? g.use_credit : 0,
            property_price: g.property_price != null ? g.property_price : 0,
            properties: g.properties || [],
          });
        });
      });
      return items;
    },
    submitOrder() {
      if (!this.addressId) {
        Toast(this.$T('观众中心请先选择地址'));
        return;
      }
      if (!this.goodsItems.length) {
        Toast(this.$T('观众中心无待结算商品'));
        return;
      }
      if (this.warnings.length) {
        Toast(this.warnings[0]);
        return;
      }
      const orderGoodsItems = this.buildOrderGoodsItems();
      if (!orderGoodsItems.length) {
        Toast(this.$T('观众中心订单预览失败'));
        return;
      }
      const that = this;
      that.submitting = true;
      that.$api.post(
        '/api/order/orderAdd',
        {
          goods_items: orderGoodsItems,
          address_id: that.addressId,
        },
        (res) => {
          that.submitting = false;
          try {
            sessionStorage.removeItem(BUY_KEY);
          } catch (e) {
            /* ignore */
          }
          const ids = (res.data && res.data.ids) || [];
          if (!ids.length) {
            Toast.success(that.$T('观众中心下单成功'));
            that.$router.replace({ path: '/spectator' });
            return;
          }
          that.orderIds = ids;
          that.payDialogShow = true;
        },
        (res) => {
          that.submitting = false;
          Toast((res && res.msg) || that.$T('观众中心下单失败'));
        }
      );
    },
    onOfflinePaid(ids) {
      this.payDialogShow = false;
      const idList = ids && ids.length ? ids : this.orderIds;
      this.$router.replace({
        path: '/spectator/offline-voucher',
        query: {
          ids: (idList || []).join(','),
          price: this.payPrice,
        },
      });
    },
    onPayClose() {
      this.payDialogShow = false;
      Toast(this.$T('观众中心可稍后上传凭证'));
      this.$router.replace({ path: '/spectator-orders' });
    },
  },
};
</script>

<style lang="scss" scoped>
.bc-spec-order {
  background: #f3f4f6;
  min-height: 50vh;
  padding: 32px 24px 100px;
}
.bc-spec-order__inner {
  max-width: 720px;
  margin: 0 auto;
}
.bc-spec-order__back {
  display: inline-block;
  margin-bottom: 12px;
  color: #5b6478;
  font-size: 14px;
  text-decoration: none;
}
.bc-spec-order__title {
  margin: 0 0 24px;
  font-size: 24px;
  font-weight: 700;
  color: #1e2842;
}
.bc-spec-order__card {
  background: #fff;
  border-radius: 12px;
  padding: 20px 22px;
  margin-bottom: 16px;
  box-shadow: 0 6px 20px rgba(30, 40, 66, 0.06);
}
.bc-spec-order__card-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 16px;
  font-size: 16px;
  font-weight: 600;
  color: #1e2842;
}
.bc-spec-order__card-head h2 {
  margin: 0;
  font-size: 16px;
}
.bc-spec-order__link {
  border: 0;
  background: none;
  color: #c2410c;
  font-size: 13px;
  cursor: pointer;
}
.bc-spec-order__hint {
  color: #6b7280;
  font-size: 14px;
}
.bc-spec-order__addr-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.bc-spec-order__addr-item {
  display: flex;
  gap: 12px;
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
}
.bc-spec-order__addr-item.is-active {
  border-color: #1e2842;
  background: #f8fafc;
}
.bc-spec-order__addr-name {
  font-size: 14px;
  font-weight: 600;
  color: #1e2842;
  margin-bottom: 4px;
}
.bc-spec-order__addr-detail {
  font-size: 13px;
  color: #6b7280;
  line-height: 1.4;
}
.bc-spec-order__field {
  margin-bottom: 12px;
}
.bc-spec-order__field label {
  display: block;
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 6px;
}
.bc-spec-order__field input,
.bc-spec-order__area-btn {
  width: 100%;
  height: 40px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 0 12px;
  font-size: 14px;
  box-sizing: border-box;
  background: #fff;
  text-align: left;
  color: #1e2842;
}
.bc-spec-order__secondary {
  margin-top: 8px;
  height: 40px;
  padding: 0 20px;
  border: 1px solid #1e2842;
  border-radius: 6px;
  background: #fff;
  color: #1e2842;
  cursor: pointer;
}
.bc-spec-order__goods {
  display: flex;
  gap: 14px;
  padding: 12px 0;
  border-bottom: 1px solid #f3f4f6;
}
.bc-spec-order__goods img {
  width: 72px;
  height: 72px;
  object-fit: cover;
  border-radius: 6px;
  background: #eef0f4;
}
.bc-spec-order__goods-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e2842;
  margin-bottom: 4px;
}
.bc-spec-order__goods-sku {
  font-size: 12px;
  color: #9ca3af;
  margin-bottom: 8px;
}
.bc-spec-order__goods-row {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #c2410c;
}
.bc-spec-order__sub {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  font-size: 13px;
  color: #6b7280;
}
.bc-spec-order__warn {
  background: #fff7ed;
  color: #c2410c;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
  font-size: 13px;
}
.bc-spec-order__footer {
  position: sticky;
  bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border-radius: 12px;
  padding: 16px 20px;
  box-shadow: 0 8px 28px rgba(30, 40, 66, 0.12);
}
.bc-spec-order__total {
  font-size: 15px;
  color: #1e2842;
}
.bc-spec-order__total strong {
  font-size: 22px;
  color: #c2410c;
}
.bc-spec-order__submit {
  height: 44px;
  padding: 0 28px;
  border: 0;
  border-radius: 8px;
  background: #c2410c;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}
.bc-spec-order__submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// SpectatorOrderConfirm.vue?4b8d2e3e